document.addEventListener("DOMContentLoaded", function () {
    const videoHero = document.querySelector("#shopify-section-template--26871322313045__video_hero_c6P3cw");
    if (!videoHero) return;
    videoHero.style.position = "relative";

    // container
    const parentElement = document.createElement('div');
    parentElement.id = 'video-hover';
    Object.assign(parentElement.style, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 5,
        display: 'grid',
        gridTemplateRows: 'auto auto auto',
        pointerEvents: 'none',
        alignItems: 'center'
    });
    videoHero.appendChild(parentElement);

    // Row 1 – collection grid
    const row1 = document.createElement('div');
    row1.classList.add('row1')
    Object.assign(row1.style, {
        display: 'grid',
        justifyContent: 'center'
    });

    const productSection = document.querySelector(".product__section--inner");
    const extraSection = document.querySelectorAll(".product__section--inner")[1];

    if (productSection) {
        row1.appendChild(productSection);
        Object.assign(productSection.style, {
            background: "transparent",
            pointerEvents: 'auto'
        });

      
        if (extraSection) {
            const extraProducts = extraSection.querySelectorAll(".col, .product__item, .whatever-class"); 
            extraProducts.forEach(product => {
                productSection.appendChild(product);
            });
            extraSection.remove();
        }
    }

    // Row 2 – heading
    const row2 = document.createElement('div');
     row2.classList.add('row2')
    const videoHeading = document.createElement('div');

   
    videoHeading.classList.add('video-heading');
    videoHeading.innerHTML = `
  <div class="video-heading-container">
    <h5 style="color:white; margin:0;">${window.videoHeroTranslations.brand_name}</h5>
    <h2 style="color:white; margin:0;">${window.videoHeroTranslations.tagline}</h2>
    <a href="/collections/all">
    <button class="video-btn button button-primary button-large" style="margin-top:1rem; pointer-events:auto;">
      ${window.videoHeroTranslations.button_text}
    </button>
    </a>
  </div>`;
    Object.assign(videoHeading.style, {
        textAlign: "center",
        background: "transparent",
        pointerEvents: 'auto',
    });
    row2.appendChild(videoHeading);
    

    // Row 3 – counter banner
    const row3 = document.createElement('div');
     row3.classList.add('row3')
    const counterup = document.querySelector(".counterup__banner--section");
    if (counterup) {
        row3.appendChild(counterup);
        Object.assign(counterup.style, {
            textAlign: "center",
            backgroundColor: "transparent",
            pointerEvents: 'auto'
        });
    }

    // Append rows
    parentElement.appendChild(row1);
    parentElement.appendChild(row2);
    parentElement.appendChild(row3);

      const cards = document.querySelectorAll(
    "#shopify-section-template--26871322313045__video_hero_c6P3cw .product__section--inner .col"
  );


  cards.forEach(card => {
    const backTitle = card.querySelector('.product__categories--content__maintitle');
    const frontWrapper = card.querySelector('.collection-card--media__wrapper');


if (backTitle && frontWrapper && !frontWrapper.querySelector('.front-card-title')) {
  const frontTitle = document.createElement('div');
  frontTitle.className = 'front-card-title';

  frontTitle.textContent = backTitle.textContent.trim();

  frontWrapper.appendChild(frontTitle);
}

    if (backTitle) {
      const titleText = backTitle.textContent.trim().toLowerCase();
      if (titleText.includes('air conditioning and ventilation of distribution cabinets')) {
        const words = backTitle.textContent.trim().split(/\s+/);
        backTitle.textContent = words.slice(0, 4).join(' ');
      }
    }
  });
   const counters = document.querySelectorAll('.counterup__banner--items__number.js-counter.h1');

  counters.forEach(counter => {
  let plusSpan = counter.querySelector('.counter-plus');
  if (!plusSpan) {
    plusSpan = document.createElement('span');
    plusSpan.classList.add('counter-plus');
    plusSpan.textContent = '+';
    counter.appendChild(plusSpan);
  }

  const observer = new MutationObserver(() => {
    const mainText = counter.textContent.replace('+', '').trim();
    if (!counter.querySelector('.counter-plus')) {
      const newPlus = document.createElement('span');
      newPlus.classList.add('counter-plus');
      newPlus.textContent = '+';
      counter.appendChild(newPlus);
    }
  });

  observer.observe(counter, { childList: true, characterData: true, subtree: true });
});
});